import {
  Button,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation } from "react-query";
import { saveMasterData } from "./services";
import { clinicId } from "../../../constants";
import useAuthentication from "@hooks/useAuthentication";
const pageTitle = "Appointment type";
function AddOrEditPage() {
  const navigate = useNavigate();
  const { user } = useAuthentication();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };
  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || e?.response?.data?.errorMessage|| "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    save([
      {
        icdId: data?.icdId || null,
        icdCode: value.icdCode,
        icdName: value.icdName,
        icdVersion: value.icdVersion,
        icdDescription: value.icdDescription,
        icdStatus: Number(value.status),
        icdCreatedById: Number(user?.userId),
        icdCreatedByDate: new Date().toISOString(),
        icdClinicId: clinicId, // Assuming current date as created date, replace with actual date if needed
      },
    ]);
  };

  const handleReset = ()=>{
     reset({
         icdCode:"",
        icdName:"",
        icdVersion:"",
        icdDescription:"",
        status: 1
     })
  }

  useEffect(() => {
    if (data) {
      reset({
        icdCode: data?.icdCode || "",
        icdName: data?.icdName || "",
        icdVersion: data?.icdVersion || "",
        icdDescription: data?.icdDes || "",
        status: data?.icdStatus,
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="icdCode"
              element="input"
              fieldProps={{ label: "ICD Code " }}
              rules={{ required: "ICD Code is required" }}
            />
            <CustomFormField
              control={control}
              name="icdName"
              element="input"
              fieldProps={{ label: "ICD name " }}
              rules={{ required: "ICD name is required" }}
            />
            <CustomFormField
              control={control}
              name="icdVersion"
              element="input"
              fieldProps={{ label: "ICD version " }}
              rules={{ required: "ICD version is required" }}
            />
            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "ICD version is required" }}
            />
            <div className="col-span-full">
              <CustomFormField
                control={control}
                name="icdDescription"
                element="input"
                fieldProps={{ label: "Enter description " }}
                rules={{ required: "Description is required" }}
              />
            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditPage;
